export default function Categories() {
    const categories = [
        { name: 'Hospitals', icon: 'local_hospital' },
        { name: 'Physiotherapy Clinics', icon: 'fitness_center' },
        { name: 'Rehabilitation Centers', icon: 'healing' },
        { name: 'Occupational Therapy Centers', icon: 'accessibility_new' },
        { name: 'Special Education Schools', icon: 'school' },
        { name: 'Sensory Integration Centers', icon: 'spa' },
        { name: 'Home Healthcare', icon: 'home_health' },
        { name: 'Home Furniture & Living', icon: 'chair' }, // ✅ fixed
    ];

    const doubledCategories = [...categories, ...categories];

    return (
        <div className="bg-surface py-8 md:py-12 overflow-hidden border-y border-outline-variant/20">
            <div className="max-w-7xl mx-auto px-6">
                <p className="text-center text-xs font-bold uppercase tracking-widest text-outline mb-6">
                    Supporting Diverse Care Industries
                </p>
                <div className="relative w-full overflow-hidden">
                    <div className="flex whitespace-nowrap animate-marquee">
                        {doubledCategories.map((cat, idx) => (
                            <div
                                key={idx}
                                className="flex items-center gap-2 mx-6 md:mx-8 text-on-surface-variant"
                            >
                                <span className="material-symbols-outlined text-xl md:text-2xl">
                                    {cat.icon}
                                </span>
                                <span className="text-sm md:text-base font-medium">
                                    {cat.name}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <style jsx>{`
                @keyframes marquee {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }
                .animate-marquee {
                    animation: marquee 20s linear infinite;
                    display: flex;
                    width: max-content;
                }
                .animate-marquee:hover {
                    animation-play-state: paused;
                }
            `}</style>
        </div>
    );
}